import React, { useEffect, useState } from "react";
import Popup from "reactjs-popup";
import plusimg from "../assets/images/dasboard/pluse.webp";
import minusimg from "../assets/images/dasboard/minus.webp";
import secureLocalStorage from "react-secure-storage";
import axios from "axios";
import { POST_WATER_INTAKE } from "../config/ApisCollection";

const WaterIntakePopup = ({
  isWaterIntakeOpen,
  setIsWaterIntakeOpen,
  currentWaterValue,
  handleDashboardApi,
  waterintakeSummary = null,
}) => {
  const [glassnum, setGlassNum] = useState(currentWaterValue);
  const [msg, setMsg] = useState(null);
  const accessToken = secureLocalStorage.getItem("accessToken");

  const UpdateWaterIntake = async () => {
    setMsg("Proccessing");
    const post_body = {
      waterTaken: glassnum,
      quantityUnit: "ml",
    };

    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };

    try {
      await axios
        .post(POST_WATER_INTAKE, post_body, post_header)
        .then((response) => {
          //   console.log(response);
          if (response.data) {
            setMsg(response.data.message);
            handleDashboardApi();
          }
        });
    } catch (error) {
      setMsg(error.response.data.error.message);
    }
    setTimeout(() => {
      setMsg(null);
      setIsWaterIntakeOpen(false);
    }, 3000);
  };

  useEffect(() => {
    // setGlassNum(currentWaterValue);

    setGlassNum(250);
  }, [currentWaterValue]);

  return (
    <Popup
      open={isWaterIntakeOpen}
      onClose={() => {
        setIsWaterIntakeOpen(false);
      }}
      position="right center"
    >
      <div>
        <h1 className="text-center text-xl">
          How much water did you
          <span className="text-orange"> consumed</span>?
        </h1>
        <p className="text-xs text-center mt-2">
          Mention the number of glasses
        </p>
      </div>
      <div className="flex justify-evenly py-10 px-5 gap-5">
        <div className="flex flex-col p-2 text-center rounded-2xl justify-center">
          <button
            className="p-2 bg-lightorange rounded"
            onClick={() => {
              if (glassnum > 250) {
                setGlassNum(glassnum - 250);
                setMsg(null);
              } else {
                setMsg("Minimum 1 glass needed");
              }
            }}
          >
            <img src={minusimg} className="m-auto" />
          </button>
        </div>
        <div className="flex flex-col p-2 text-center gap-2">
          <h1 className="text-6xl">{glassnum / 250}</h1>
          <h1 className="text-xl">Glass</h1>
        </div>
        <div className="flex flex-col p-2 text-center justify-center">
          <button
            className="p-2 bg-lightorange rounded"
            onClick={() => {
              if (glassnum < 1000) {
                setGlassNum(glassnum + 250);
                setMsg(null);
              } else {
                setMsg("Maximum 4 glass allowed");
              }
            }}
          >
            <img src={plusimg} className="m-auto" />
          </button>
        </div>
      </div>
      <div className="items-center ">
        <p className="text-[#28a745] text-center mb-2 text-capitalize">{msg}</p>
        <h1 className="text-center text-xs !mb-3">1 glass = 250 ml </h1>

        {waterintakeSummary?.waterRecommendation >=
        glassnum + waterintakeSummary?.todayTotalWaterintake ? (
          msg !== "Proccessing" ? (
            <button
              className="px-5 py-2 text-center bg-orange !text-[#fff] rounded-xl shadow-2xl w-full "
              onClick={UpdateWaterIntake}
            >
              Update water log
            </button>
          ) : (
            <></>
          )
        ) : (
          <p className="text-center text-red">Target completed</p>
        )}
      </div>
    </Popup>
  );
};

export default WaterIntakePopup;
